/* global console */

/* eslint-disable no-console */
// TODO: Use "warning" npm module like React is switching to.
export default {
  warn: function (message) {
    if (process.env.NODE_ENV !== "production") {
      if (console && console.warn) {
        console.warn(message);
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/es/victory-util/log.js
// module id = ./node_modules/victory-core/es/victory-util/log.js
// module chunks = 1